export const JOURNEYS = {
  STANDARD: 'standard',
  UTILITY: 'utility',
};
